<template>
  <q-btn v-if="showBuildingReportBtn" size="sm" outline @click="navigateToStartingPage">
    Start another report
  </q-btn>
</template>

<script>
import { mapState } from 'vuex'

export default {
  computed: {
    ...mapState('reports', ['showBuildingReportBtn'])
  },

  methods: {
    navigateToStartingPage() {
      this.$router.push('/reports')
    }
  }
}
</script>
